<div class="mt-6"></div>
<div *ngIf="formHandler.getFormStatus() !== 'success'">
  <h1 class="title is-5 mb-4">Passwort setzen</h1>
</div>
<iw-shared-form-error [apiError]="formHandler.getFormError()"></iw-shared-form-error>
<div *ngIf="formHandler.getFormStatus() == 'success'">
  <p>Das Passwort wurde erfolgreich gespeichert. Sie können sich mit Ihren neuen Zugangsdaten <a routerLink="/login">hier </a>
    einloggen.
  </p>
</div>
<div>
  <div *ngIf="formHandler.getFormStatus() !== 'success'">
    <div>
      <div class="is-block">
        <div class="field" [formGroup]="form">
          <div class="control">
            <input class="input" type="password" formControlName="password" placeholder="Neues Passwort" value="">
          </div>
          <p class="help is-danger" *ngIf="isFormKeyInvalid('password')">Ihr Passwort muss 8 Zeichen haben und
            mindestens einen Kleinbuchstaben, Großbuchstaben sowie ein Sonderzeichen enthalten.</p>
        </div>
        <div class="field" [formGroup]="form">
          <div class="control">
            <input class="input" type="password" formControlName="passwordRetype"
                   placeholder="Neues Passwort (wiederholen)" value="">
          </div>
          <p class="help is-danger" *ngIf="isFormKeyInvalid('passwordRetype')">Die Passwörter stimmen nicht überein.</p>
        </div>
        <iw-shared-form-submit-button [formStatus]="formHandler.getFormStatus()" submitLabel="Passwort setzen"
                                      (submit)="submit()"></iw-shared-form-submit-button>
      </div>
    </div>
  </div>
</div>

